import { useTransferData } from '@/shared/hooks/useTransferData';
import { inspectionTypeService } from '@/services/inspectionType.service';
import { InspectionType } from '@/services/types/user.types';

export function useInspectionTypesTransfer() {
  const { items: inspectionTypes } = useTransferData<InspectionType>({
    fetchFn: () => inspectionTypeService.getAllInspectionTypes(),
    mapper: {
      key: (item) => item.id,
      title: (item) => item.name,
      description: (item) => item.description,
      disabled: () => false,
    },
    errorMessage: 'Erro ao buscar os dados dos Tipos de Inspeção.',
  });

  return {
    inspectionTypes,
  };
}
